const MEMBERSHIP_RETENTION_PAGE = '#membership_retention/';
const MEMBERSHIP_CANCELLATION_PAGE = '#membership_cancellation/';
const MEMBERSHIP_CANCELLATION_REQUEST_PAGE = '#membership_cancellation_request/';
const MEMBERSHIP_RIGHT_OF_WITHDRAWAL_PAGE = '#right_of_withdrawal/';
const MEMBERSHIP_REMEDIATION_REQUEST_PAGE = '#remediation_request/';
const MEMBERSHIP_REMEDIATION_PROCESS_PAGE = '#remediation_process/';
const MEMBERSHIP_STANDALONE_PAGE = '#standalone/';
const MEMBERSHIP_REACTIVATION_MY_TRIPS_PAGE = '#membership_mytrips_reactivation/';
const MEMBERSHIP_REFERRAL_INVITE_RECOMMENDATION = '#membership_referral_invite_recommendations/';

const MEMBERSHIP_REFERRAL_INVITE_RECOMMENDATION_SOCIAL = 'utm_medium=social';

const MEMBERSHIP_PAGES_WITH_OLD_HEADER = [
    MEMBERSHIP_REACTIVATION_MY_TRIPS_PAGE,
    MEMBERSHIP_RETENTION_PAGE,
    MEMBERSHIP_CANCELLATION_PAGE,
    MEMBERSHIP_CANCELLATION_REQUEST_PAGE,
    MEMBERSHIP_RIGHT_OF_WITHDRAWAL_PAGE,
    MEMBERSHIP_REMEDIATION_REQUEST_PAGE,
    MEMBERSHIP_REMEDIATION_PROCESS_PAGE,
];
const pageWithCustomFooter = [
    MEMBERSHIP_RETENTION_PAGE,
    MEMBERSHIP_CANCELLATION_PAGE,
    MEMBERSHIP_CANCELLATION_REQUEST_PAGE,
    MEMBERSHIP_RIGHT_OF_WITHDRAWAL_PAGE,
    MEMBERSHIP_REMEDIATION_REQUEST_PAGE,
    MEMBERSHIP_REMEDIATION_PROCESS_PAGE,
    MEMBERSHIP_STANDALONE_PAGE,
];
const pageWithCustomHeader = [
    MEMBERSHIP_STANDALONE_PAGE,
];

const isDesktopFlow = () => Odigeo.SessionScope.flow === 'desktop';
const isMembershipReferralInviteRecommendationPage = () => window.location.hash
    .includes(MEMBERSHIP_REFERRAL_INVITE_RECOMMENDATION);
const isMembershipReferralInviteRecommendationPageSocialCondition = () => window.location.hash
    .includes(MEMBERSHIP_REFERRAL_INVITE_RECOMMENDATION_SOCIAL);
const isMembershipCancellationPages = () =>
    MEMBERSHIP_CANCELLATION_PAGE === window.location.hash || MEMBERSHIP_CANCELLATION_REQUEST_PAGE === window.location.hash;
const isMembershipMyTripsReactivationPage = () => MEMBERSHIP_REACTIVATION_MY_TRIPS_PAGE === window.location.hash;
export const isMembershipPageWithOldHeader = () => MEMBERSHIP_PAGES_WITH_OLD_HEADER.includes(window.location.hash);

export const membershipPageRemoveDidomiPopup = isMembershipReferralInviteRecommendationPage()
    && !isMembershipReferralInviteRecommendationPageSocialCondition();

export const manageContainersVisibility = () => {
    manageHeaderVisibility();
    manageFooterVisibility();
    manageDidomiVisibility();
};

const manageHeaderVisibility = () => {
    if (!pageWithCustomHeader.some((page) => window.location.hash.includes(page))) {
        if (isMembershipPageWithOldHeader()) {
            if ((isDesktopFlow() && isMembershipCancellationPages())
                || isMembershipMyTripsReactivationPage()) {
                $('#membership-pages-header-old-variation').removeClass('odf-hidden');
            }
        } else {
            $('#membership-pages-header').removeClass('odf-hidden');
        }
    }
};

const manageFooterVisibility = () => {
    if (!pageWithCustomFooter.some((page) => window.location.hash.includes(page))) {
        $('#membership-pages-footer').removeClass('odf-hidden');
    }
};

const manageDidomiVisibility = () => {
    if (Odigeo.Device.navigator.isNative() || membershipPageRemoveDidomiPopup) {
        $('#didomi-host').addClass('odf-hidden');
        $('body').removeClass('didomi-popup-open');
    }
};
